import { ucfirst } from "../plugins/uniweb";

/**
 * Class ActivityManager.js
 *
 * @class ActivityManager
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.7] app/src/manager/ActivityManager.js
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export class ActivityManager {
  constructor(translator) {
    this._translator = translator;
  }

  getTextForStepGoalClass(level) {
    const levelText = ucfirst(
      this._translator.t(
        `physicalActivityStepGoals.${level.toLowerCase()}`,
        { catalog: 'app_mobile' }
      )
    );
    const stepsText = this._translator.t(
      "stepCounterTool.stepsCounter",
      { catalog: 'app_mobile' }
    ).toLowerCase();

    switch (level.toLowerCase()) {
      case "inactive":
        return `${levelText} (<2500 ${stepsText})`;
      case "beginner":
        return `${levelText} (2500-4999 ${stepsText})`;
      case "intermediate":
        return `${levelText} (5000-7500 ${stepsText})`;
      case "advanced":
        return `${levelText} (>7500 ${stepsText})`;
    }
  }
}

ActivityManager.INACTIVE = 0
ActivityManager.BEGINNER = 2500
ActivityManager.INTERMEDIATE = 5000
ActivityManager.ADVANCED = 7500

